import { render, staticRenderFns } from "./GroupInterests.vue?vue&type=template&id=825db536&scoped=true&"
import script from "./GroupInterests.vue?vue&type=script&lang=js&"
export * from "./GroupInterests.vue?vue&type=script&lang=js&"
import style0 from "./GroupInterests.vue?vue&type=style&index=0&id=825db536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825db536",
  null
  
)

export default component.exports